import sortBy from 'lodash/sortBy'
import { useTranslation } from 'react-i18next'

import { AutocompleteInput } from '~/basket/view/components/AutocompleteInput'

import { SelectableDestinationCountry } from '~/basket/model/reducers'

type Props = {
  name: string
  selectableDestinationCountries: SelectableDestinationCountry[]
}

export const DestinationCountryInput = ({ name, selectableDestinationCountries }: Props) => {
  const { t } = useTranslation()
  // eslint-disable-next-line @typescript-eslint/no-shadow
  function mapToOptions(selectableDestinationCountries: SelectableDestinationCountry[]) {
    return selectableDestinationCountries.map(({ code, isPopular }) => ({
      label: t(`inputs.destinationInput.country_${code}`),
      code,
      isPopular,
    }))
  }

  const options = [
    ...mapToOptions(
      sortBy(
        selectableDestinationCountries.filter(({ isPopular }) => isPopular),
        ({ ordering }) => ordering
      )
    ),
    ...sortBy(mapToOptions(selectableDestinationCountries.filter(({ isPopular }) => !isPopular)), ({ label }) => label),
  ]

  type Option = {
    code: string
    label: string
    isPopular: boolean
  }

  return (
    <AutocompleteInput<Option, undefined>
      name={name}
      label={t('select_destination')}
      options={options}
      getOptionLabel={(option) => option.label}
      getOptionValue={(option) => option.code}
      groupBy={(option) => (option.isPopular ? t('country_popular') : t('country_allcountries'))}
      fullWidth
    />
  )
}
